export default "<p>Auth works!</p>\r\n<button mat-flat-button color=\"primary\">Primary</button>\r\n<router-outlet></router-outlet>\r\n"